import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';

/*
import cloud1 from '../img/cloud1.png'
import cloud2 from '../img/cloud2.png'
import cloud3 from '../img/cloud3.png'
*/


export class Management extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDescription: true,
    }

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    console.log("Futo Spec hovered()")
    this.setState({ showDescription: true })
  }

  unHovered(elem) {
    this.setState({ showDescription: false })
  }

  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const description = "Good managment: extremely important, extremely neglected. Some thoughts on how to deliver better product faster."
    return (
      <div className='idea-description'>
        { description }
      </div>
    )
  }


  render() {

    const fontSize = 24
    const boxStyle = {
      flex: 1,
      //position: 'absolute',
      border: "2px solid #1F557D",
      borderRadius: '6px',
      boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
      background: "#ffffff",
      //fontFamily: "BeyondInfinity",
      fontFamily: 'Geo Sans Light Oblique',
      fontSize: `${fontSize}px`,
      padding: "10px",
      //paddingTop: "15px",
      marginLeft: "5px",
      marginRight: "5px",
    }

    return (
      <div className="idea-container">
        <div className='idea-box-parent'>
          <div
            className="idea-box"
            onMouseOver={this.hovered}
          >
            <a href="https://seanfelipe.github.io/tech/management/process/fundamentals/testing/2020/04/10/modern-sqa-fundmentals.html">
              Management
            </a>
          </div>
        </div>
        <div className="tool-description-container">
          { this.state.showDescription
            ? this.renderAppDescriptionBox()
            : null
          }
        </div>
      </div>
    )
  }
}
